require('./tabbedBoxLabel.scss');

const PropTypes = require('prop-types');

const React = require('react');
const classNames = require('classnames');

class TabbedBoxLabel extends React.Component {
    constructor(props) {
        super(props);
        this.handleSelectedTab = this.handleSelectedTab.bind(this);
    }

    handleSelectedTab(index) {
        if (this.props.getContextData) {
            const widthOption = this[`option${index.toString()}`].offsetWidth;
            const leftOption = this[`option${index.toString()}`].offsetLeft;
            this.props.onTabSelection(this.props.index, widthOption, leftOption);
        } else {
            this.props.onTabSelection(this.props.index);
        }
    }

    render() {
        const { animated, label, index, active, id, tabsSize, isResponsive } = this.props;
        const tabLabelClassname = classNames('tabbed-box__tab', {
            'col-xs-6': isResponsive && tabsSize === 2,
            'tabbed-box__no-animated-tab': !animated,
            'tabbed-box__no-animated-tab--active': !animated && active,
            'tabbed-box__animated-tab': animated,
            'tabbed-box__animated-tab--active': animated && active,
        });
        
        return (
            <li
                id={id}
                key={index}
                className={tabLabelClassname}
                onClick={() => this.handleSelectedTab(index)}
                ref={option => {this[`option${index.toString()}`] = option;}}
            >
                <span className="tabbed-box__inner">
                    {label}
                </span>
            </li>
        );
    }
}

TabbedBoxLabel.propTypes = {
    animated: PropTypes.bool,
    label: PropTypes.string.isRequired,
    active: PropTypes.bool.isRequired,
    id: PropTypes.string,
    index: PropTypes.number,
    isResponsive: PropTypes.bool,
    onTabSelection: PropTypes.func,
    getContextData: PropTypes.bool,
    tabsSize: PropTypes.number,
}

TabbedBoxLabel.defaultProps = {
    isResponsive: false,
}

module.exports = TabbedBoxLabel;